import { getHtml } from "@/Services/TherapyApi/LegalAgreements";

async function getHTMLLegalAgreementAH(userId: string, contractUuid: string): Promise<string | null> {
  return getHtml(userId, contractUuid);
}

export default getHTMLLegalAgreementAH;
